<div>
    <div *ngIf="type === ProjectTypeEnum.COLLAGE_TYPE && !shouldSkipLayers"
        class="create-project-header twc-col-lg-6 twc-col-md-12">
        <div *ngIf="selectedLayers.length; else noSelectedLayers" class="twc-mb-5">
            <div class="twc-body font-bold twc-mb-1">
                {{ 'CREATE_PROJECT.LAYER_SELECTED_NOTICE' | translate}}
            </div>
            <div class="selected-layers-table">
                <cw-grid [columns]="columns" [data]="selectedLayers"></cw-grid>
            </div>
        </div>
        <ng-template #noSelectedLayers>
            <div class="twc-message-box twc-message-box-warning">
                {{ 'CREATE_PROJECT.NO_LAYER_SELECTED_NOTICE' | translate}}
            </div>
        </ng-template>
    </div>

    <form [formGroup]="createProjectForm" class="twc-form">
        <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
            <label for="name" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.NAME' | translate }}</label>
            <div class="twc-form-element">
                <input id="name" formControlName="name" class="twc-input" required [maxLength]="defaultMaxLength"
                    placeholder="{{'CREATE_PROJECT.PLACEHOLDER_NAME' | translate}}">
            </div>
        </div>
        <div class="twc-form-control twc-col-lg-6 twc-col-md-12">
            <label for="description" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.DESCRIPTION' | translate
                }}</label>
            <div class="twc-form-element">
                <textarea id="description" formControlName="description" class="twc-textarea"
                    [maxLength]="defaultMaxLength"
                    placeholder="{{'CREATE_PROJECT.PLACEHOLDER_DESCRIPTION' | translate}}">
            </textarea>
            </div>
        </div>
        <div class="twc-form-control twc-col-lg-6 twc-col-md-12" *ngIf="isVisible('projection')">
            <label for="projection" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.COORDINATE' | translate
                }}</label>
            <div class="twc-form-element">
                <cw-crs-search placeholder="{{'CREATE_PROJECT.PLACEHOLDER_COORDINATE' | translate}}" type="crs"
                    [selectItem]="getProjection()" (selectItemChange)="setSelectedCRS($event)"></cw-crs-search>
            </div>
        </div>
        <div class="twc-form-control twc-col-lg-6 twc-col-md-12 geoid-block" *ngIf="isVisible('geoid')">
            <label for="geoid" class="twc-form-label font-bold">{{ 'PROJECTS.GEOID' | translate }}</label>
            <div class="twc-form-element">
                <cw-crs-search placeholder="{{'CREATE_PROJECT.PLACEHOLDER_GEOID' | translate}}" type="geoid"
                    [selectItem]="jobSite?.geoid || ''" (selectItemChange)="setSelectedGeoid($event)"></cw-crs-search>
            </div>
        </div>
        <div *ngIf="!isSite" class="twc-form-control twc-col-lg-6 twc-col-md-12 geoid-block">
            <label for="captureDate" class="twc-form-label font-bold">{{ 'CREATE_PROJECT.CAPTURE_DATE' | translate
                }}</label>
            <twc-date-picker [maxDate]="today">
                <input twcInputDate formControlName="captureDate">
            </twc-date-picker>
        </div>

        <!-- TODO: Workaround until TWC fixed the disabled property -->
        <button *ngIf="!isCreateButtonHidden" class="twc-button twc-button-primary twc-mt-5" type="button"
            [twcLoading]="loading" [attr.disabled]="!createProjectForm.valid || null" (click)="onCreateProject()">
            <span *ngIf="type !== ProjectTypeEnum.SCAN; else scanTitle">
                {{'CREATE_PROJECT.TITLE' | translate}}
            </span>
            <ng-template #scanTitle>
                <span>
                    {{'CREATE_PROJECT.EMPTY_SCAN' | translate}}
                </span>
            </ng-template>
        </button>
    </form>
</div>